import React from 'react';
import { Card, Typography, Space } from 'antd';

const { Title, Text } = Typography;

export interface PortalLayoutProps {
  title: string;
  shopName: string;
  subtitle?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

const PortalLayout: React.FC<PortalLayoutProps> = ({ title, shopName, subtitle, children, footer }) => {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#f5f5f5',
      padding: '16px 0',
      display: 'flex',
      justifyContent: 'center',
    }}>
      <div style={{ width: '100%', maxWidth: 640, padding: '0 12px' }}>
        <Card>
          <Space direction="vertical" size="small" style={{ width: '100%' }}>
            <Text type="secondary" style={{ fontSize: 12, letterSpacing: 1 }}>
              {shopName.toUpperCase()}
            </Text>
            <Title level={3} style={{ margin: 0 }}>{title}</Title>
            {subtitle && <Text type="secondary">{subtitle}</Text>}
          </Space>
          <div style={{ marginTop: 16 }}>{children}</div>
        </Card>
        {footer && <div style={{ marginTop: 16, textAlign: 'center' }}>{footer}</div>}
      </div>
    </div>
  );
};

export default PortalLayout;
